import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export const SelectYearPicker = ({ onChange, value, disabled = false }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        views={["year"]}
        value={value ? dayjs().year(value) : null} // ✅ fix here
        className="select-date"
        slotProps={{
          textField: {
            disabled: disabled,
            fullWidth: true,
            InputProps: {
              sx: {
                "& input": {
                  width: "100%",
                  padding: "8.5px 14px",
                  fontFamily: "'PublicSans', 'Siemreap', sans-serif",
                },
              },
            },
          },
        }}
        onChange={(val) => {
          if (val) {
            onChange(val.year()); // returns number only
          } else {
            onChange("");
          }
        }}
      />
    </LocalizationProvider>
  );
};
